export const niceStep = (range: number, targetTicks: number): number => {
    if (range <= 0) return 1

    const rough = range / Math.max(1, targetTicks)
    const magnitude = Math.pow(10, Math.floor(Math.log10(rough)))
    const residual = rough / magnitude
    const pick = [1, 2, 2.5, 5, 10].find(candidate => candidate >= residual - 1e-9) ?? 10

    return pick * magnitude
}

export interface Scale {
    min: number
    max: number
    ticks: Array<number>
}

export const niceScale = (values: Array<number>, targetTicks: number = 4, floorAtZero: boolean = true): Scale => {
    const finite = values.filter(value => Number.isFinite(value))
    const rawMax = finite.length ? Math.max(...finite) : 1
    const rawMin = finite.length ? Math.min(...finite) : 0
    const min = floorAtZero ? Math.min(0, rawMin) : rawMin
    const step = niceStep(rawMax - min || 1, targetTicks)
    const max = Math.ceil(rawMax / step) * step || step
    const start = Math.floor(min / step) * step
    const ticks: Array<number> = []

    for (let value = start; value <= max + step / 2; value += step) ticks.push(Number(value.toFixed(6)))

    return { min: start, max, ticks }
}

export const formatTick = (value: number): string => {
    const abs = Math.abs(value)

    if (abs >= 1000) return value.toLocaleString('en-GB').replace(/,/g, ' ')
    if (Number.isInteger(value)) return String(value)

    return value.toFixed(abs < 10 ? 1 : 0)
}

export const formatValue = (value: number | null, unit?: string): string => {
    if (value === null || !Number.isFinite(value)) return 'No data'

    const text = Math.abs(value) >= 1000 ? value.toLocaleString('en-GB').replace(/,/g, ' ') : String(Number(value.toFixed(2)))

    if (!unit) return text

    return unit === '%' ? `${text}%` : `${text} ${unit}`
}
